/**
 * @Description 文件功能说明：弹窗 项目信息
 * @Author cc
 * @Time 2025/11/3
 */
/* HTML */
<template>
	<el-dialog :title="dialogForm.title" :visible.sync="dialogForm.dialogFormVisible" :close-on-click-modal="false" :modal-append-to-body="false" :modal="false" custom-class="form-dialog" v-dialogDrag class="dialog_title" @close="handleDialogClose">

		<el-form :model="dialogRowForm" :rules="rules" ref="dialogRowForm" label-width="120px">
			<el-form-item label="项目名称：" prop="projectName" style="margin-bottom: 20px;">
				<el-input v-model="dialogRowForm.projectName" auto-complete="off" autocomplete="false" clearable/>
			</el-form-item>
			<el-form-item label="项目地址：" prop="website" style="margin-bottom: 20px;">
				<el-input v-model="dialogRowForm.website" auto-complete="off" autocomplete="false" clearable/>
			</el-form-item>
			<el-form-item label="中心纬度：" prop="centerLat" style="margin-bottom: 20px;">
				<el-input v-model="dialogRowForm.centerLat" auto-complete="off" autocomplete="false" clearable/>
			</el-form-item>
			<el-form-item label="中心经度：" prop="centerLng" style="margin-bottom: 20px;">
				<el-input v-model="dialogRowForm.centerLng" auto-complete="off" autocomplete="false" clearable/>
			</el-form-item>

			<el-form-item label-width="0px" class="btn-form-item-c" style="padding-top: 10px;text-align: center;">
				<el-button type="primary" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
			</el-form-item>
		</el-form>
	</el-dialog>

</template>

/* JS */
<script>
	import ApiOrgGnss from '@/request/api-org_gnss'
	import { checkEmpty, validFormat, checkFormat } from '@/global/global-valid'

	export default {
		/**
		 * @Des 组件名
		 * @Auth CC
		 * @Date 2025/11/3
		 */
		name: 'OrgDialog',
		
		/**
		 * @Des 属性值
		 * @Auth
		 * @Date 
		 */
        props: {
        	/**
			 * @Des 经纬度
			 * @Auth
			 * @Date
			 */
        	lnglat: {
				type: Object,
				default: function() {
					return {};
				}
			},// lnglat
        },// props
		
		/**
		 * @Des 数据定义
		 * @Auth CC
		 * @Date 2025/11/3
		 */
		data() {
			return {
				/**
				 * @Des 弹窗表单
				 * @Auth CC
				 * @Date 2025/11/3
				 */
				dialogForm: {
					isEdit: true,
					title: "新增项目",
					dialogFormVisible: false,
					submitButton: '提交'
				},
				/**
				 * @Des 弹窗行值
				 * @Auth CC
				 * @Date 2025/11/3
				 */
				dialogRowForm: {
					projectId: '',
					projectName: "",
					website: "",
					coordinate: 2,
					centerLat: "",
					centerLng: "",
				},// dialogRowForm
				/**
				 * @Des 弹窗规则
				 * @Auth CC
				 * @Date 2025/11/3
				 */
				rules: {
					projectName: [{
							required: true,
							message: '请输入项目名称',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if(!checkFormat(value, validFormat.password) && false) {
									new callback(new Error("6-18位，可包含数字、字母、英文符号"));
								} else {
									callback()
								}
							},
							trigger: "blur"
						}
					],
					website: [{
							required: false,
							message: '请输入项目地址',
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if(!this.$checkEmpty(value) && !checkFormat(value, validFormat.urlRegExp)) {
									new callback(new Error("项目地址错误"));
								} else {
									callback()
								}
							},
							trigger: "blur"
						}
					],// website
					centerLat: [{
						required: true,
						message: '请输入中心纬度',
						trigger: 'blur'
					}, ],
					centerLng: [{
						required: true,
						message: '请再次输入中心经度',
						trigger: 'blur'
					}, ],
				},// rules
				
				// 锁
				locked: false,
				
			}// return
		},// data
		/**
		 * @Des 方法定义
		 * @Auth CC
		 * @Date 2025/11/3
		 */
		methods: {
			/**
			 * @Des 弹窗打开
			 * @Auth CC
			 * @Date 2025/11/3
			 */
			openDialog(editFlag, data, rowIndex) {
				// console.log(data);
				this.dialogForm.dialogFormVisible = true;

				this.dialogForm.editFlag = editFlag;
				this.dialogForm.title = (!editFlag ? '新增项目' : '编辑项目');
				this.dialogForm.submitButton = "提交";

				if(!this.$checkEmpty(data)) {
					// 表单
					this.dialogRowForm = Object.assign({}, this.dialogRowForm, data, {
						rowIndex: rowIndex
					});
				}
				this.dialogRowForm.centerLat = this.lnglat.lat;
				this.dialogRowForm.centerLng = this.lnglat.lng;

			}, // openDialog
			/**
			 * @Des 弹窗关闭
			 * @Auth CC
			 * @Date 2025/11/3
			 */
			handleDialogClose() {
				this.reset()
			}, // handleDialogClose
			/**
			 * @Des 重置方法
			 * @Auth CC
			 * @Date 2025/11/3
			 */
			reset() {
				this.cleanData(this.dialogRowForm);
				this.cleanValidate('dialogRowForm');
			}, // reset
			/**
			 * @Des 提交方法
			 * @Auth CC
			 * @Date 2025/11/3
			 */
			submitForm() {
				// 交互锁
				if (this.locked) return false;
				
				this.$refs.dialogRowForm.validate(valid => {
					if(!valid) return false;
					
					// 交互锁
					this.locked = true;
					let submitApi = this.dialogForm.editFlag ? ApiOrgGnss.updateProjectApi : ApiOrgGnss.addProjectApi;
					this.$request.postJsonRequest(submitApi, {
						projectId: this.dialogRowForm.projectId,
						projectName: this.dialogRowForm.projectName,
						website: this.dialogRowForm.website,
						coordinate: this.dialogRowForm.coordinate || 2,
						centerLat: this.dialogRowForm.centerLat,
						centerLng: this.dialogRowForm.centerLng,
					}).then(result => {
						// 交互锁
						this.locked = false;
						
						// console.log(result); return false;
						if(result.code == 0) {
							this.dialogForm.dialogFormVisible = false;
							// 添加成功
							this.$emit("cancel");
							
							this.$message({
								message: this.dialogForm.editFlag ? '项目修改成功！' : '项目新增成功！',
								type: 'success',
								showClose: true,
								dangerouslyUseHTMLString: true,
								onClose: (() => {})
							});

						} else {
							this.$message({
								message: result.msg,
								type: 'error',
								showClose: true,
								dangerouslyUseHTMLString: true
							});
						}
						
						if (this.dialogForm.editFlag) {
			              // 刷新列表
			              this.$emit("setRow", this.dialogRowForm, this.dialogRowForm.rowIndex);
			            } else {
			              // 添加成功
			              this.$emit("setTotal", 0);
			            }
					}).catch(error => {
						// 交互锁
						this.locked = false;
						console.error('修改项目异常', ApiOrgGnss.updatePwdApi, error);
					})
				})
			}, // submitForm
			/**
			 * @Des 清除验证
			 * @Auth CC
			 * @Date 2025/11/3
			 */
			cleanValidate(formName) {
				// 清除表单校验的提示
				if(this.$refs[formName]) {
					// 延时执行
					this.$nextTick(function() {
						this.$refs[formName].clearValidate();
					})
				};
			}, // cleanValidate
			/**
			 * @Des 清理数据
			 * @Auth CC
			 * @Date 2025/11/3
			 */
			cleanData(form) {
				this.$nextTick(function() {
					form.projectId = '';
					form.projectName = '';
					form.website = '';
					form.coordinate = 2;
					form.centerLat = '';
					form.centerLng = '';
				})
			},// cleanData
		},// methods
		/**
		 * @Des 监听
		 * @Auth
		 * @Date 
		 */
		watch: {
			/**
	         * @Des 分页监听
	         * @Auth
	         * @Date 2021/6/4
	         */
	        lnglat: {
	            handler(newVal, oldVal){
	                this.dialogRowForm.centerLat = this.lnglat.lat;
	                this.dialogRowForm.centerLng = this.lnglat.lng;
	            },
	            immediate: true,
	            deep:true,
	        },// lnglat
		},// watch
		
		/**
		 * @Des 实时计算
		 * @Auth
		 * @Date 
		 */
		computed: {
			
		},// computed
	}
</script>

/* CSS */
<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components_outdoor/Organization/OrgDialog.vue